import {CasesReports} from "@/store/reports/models";

export interface ReportsState {
  casesReports: CasesReports;
  activeReportId: number | null;
  isCaseReportValid: boolean;
}


const state = {
  casesReports: {},
  activeReportId: null,
  isCaseReportValid: true
} as ReportsState;

export default state;
